import { useState } from 'react';
import { useFitnessStore } from '../../../store/fitnessStore';
import { PLANS } from '../../../services/stripe';

export default function ProfileScreen() {
  const profile = useFitnessStore((s) => s.profile);
  const setProfile = useFitnessStore((s) => s.setProfile);
  const openModal = useFitnessStore((s) => s.openModal);
  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState(profile);

  function save() {
    setProfile(form);
    setEditing(false);
  }

  const tier = profile.subscriptionTier;

  return (
    <div style={{ padding: '20px 16px 0' }}>
      <div style={{ fontFamily: 'Bebas Neue', fontSize: 30, marginBottom: 16 }}>PROFILE</div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 20 }}>
        <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'linear-gradient(135deg,#E8FF47,#FF6B35)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, marginBottom: 10 }}>💪</div>
        <div style={{ fontSize: 18, fontWeight: 600 }}>{profile.name}</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{profile.fitnessLevel} athlete</div>
        <div
          style={{
            marginTop: 8, padding: '4px 14px', borderRadius: 20, fontSize: 11, fontWeight: 700, letterSpacing: 0.5,
            background: tier === 'elite' ? 'rgba(180,126,255,0.15)' : tier === 'pro' ? 'rgba(232,255,71,0.12)' : 'rgba(255,255,255,0.07)',
            color: tier === 'elite' ? '#B47EFF' : tier === 'pro' ? '#E8FF47' : 'rgba(255,255,255,0.4)',
            border: `1px solid ${tier === 'elite' ? 'rgba(180,126,255,0.3)' : tier === 'pro' ? 'rgba(232,255,71,0.3)' : 'rgba(255,255,255,0.1)'}`,
          }}
        >
          {tier.toUpperCase()} PLAN
        </div>
      </div>

      {tier === 'free' && (
        <div style={{ background: 'linear-gradient(135deg,rgba(255,107,53,0.12),rgba(232,255,71,0.06))', border: '1px solid rgba(255,107,53,0.25)', borderRadius: 16, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>Unlock Your Full Potential</div>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginBottom: 12 }}>AI plans, sport training, nutrition tracking & more</div>
          <button type="button" onClick={() => openModal('upgrade')} className="fit-btn-primary">Upgrade to Pro — $9.99/mo</button>
        </div>
      )}

      {tier !== 'free' && (
        <div className="fit-card" style={{ marginBottom: 14 }}>
          <div className="fit-section-label">SUBSCRIPTION</div>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 8 }}>{PLANS[tier]?.name} Plan</div>
          <button type="button" onClick={() => openModal('upgrade')} className="fit-btn-ghost" style={{ width: '100%' }}>Manage Subscription</button>
        </div>
      )}

      <div className="fit-card" style={{ marginBottom: 14 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
          <div className="fit-section-label" style={{ marginBottom: 0 }}>YOUR STATS</div>
          <button
            type="button"
            onClick={() => (editing ? save() : setEditing(true))}
            style={{ background: editing ? '#E8FF47' : 'rgba(255,255,255,0.07)', color: editing ? '#0A0A0B' : 'rgba(255,255,255,0.6)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
          >
            {editing ? 'Save' : 'Edit'}
          </button>
        </div>
        {[
          { key: 'name', label: 'Name', type: 'text' },
          { key: 'weight', label: 'Weight (kg)', type: 'number' },
          { key: 'height', label: 'Height (cm)', type: 'number' },
          { key: 'age', label: 'Age', type: 'number' },
        ].map(({ key, label, type }) => (
          <div key={key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid rgba(255,255,255,0.04)' }}>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>{label}</div>
            {editing ? (
              <input
                type={type}
                value={form[key] || ''}
                onChange={(e) => setForm((f) => ({ ...f, [key]: type === 'number' ? Number(e.target.value) : e.target.value }))}
                style={{ background: '#1C1C1F', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, padding: '4px 10px', color: '#fff', fontFamily: 'DM Sans', fontSize: 13, width: 110, textAlign: 'right', outline: 'none' }}
              />
            ) : (
              <div style={{ fontSize: 13, fontWeight: 500 }}>{profile[key]}{key === 'weight' ? 'kg' : key === 'height' ? 'cm' : ''}</div>
            )}
          </div>
        ))}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 10 }}>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>Level</div>
          {editing ? (
            <select
              value={form.fitnessLevel}
              onChange={(e) => setForm((f) => ({ ...f, fitnessLevel: e.target.value }))}
              className="fit-select"
              style={{ width: 130 }}
            >
              {['beginner', 'intermediate', 'advanced', 'elite'].map((l) => <option key={l} value={l}>{l}</option>)}
            </select>
          ) : (
            <span className="fit-tag fit-tag-lime">{profile.fitnessLevel}</span>
          )}
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 10 }}>
          <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)' }}>Gender</div>
          {editing ? (
            <select value={form.gender} onChange={(e) => setForm((f) => ({ ...f, gender: e.target.value }))} className="fit-select" style={{ width: 130 }}>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          ) : (
            <div style={{ fontSize: 13, fontWeight: 500 }}>{profile.gender}</div>
          )}
        </div>
      </div>

      <div className="fit-card">
        <div className="fit-section-label">SETTINGS</div>
        <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', lineHeight: 1.6 }}>
          Data is stored locally on this device. Connect Supabase for cloud sync (coming soon).
        </div>
      </div>
    </div>
  );
}
